import Router, { Route } from 'vue-router'
import Meta from 'vue-meta'
import { UserPermissionChecker } from '@/router/UserPermissionChecker'
import Vue from 'vue'
import routes from '@/router/routes'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeResolve(async (to: Route, from: Route, next: any) => {
  if (to.matched.some(record => record.meta.needsAdminRole)) {
    const isAdmin = await UserPermissionChecker.isUserAdmin()

    if (!isAdmin) {
      next({ name: 'error401' })
    }
  }

  next()
})

export default router
